import { useState } from 'react';
import { OutlineButton, Table, TableHeader } from '@recargas-dominicanas/core/components';
import type { IBusinessUser } from '@recargas-dominicanas/core/types';
import { BusinessStore } from '../../../store/businessStore';
import { AddBusinessUserModal } from './add-business-user-modal/add-business-user-modal.component';
import { BusinessUserDetailsModal } from './business-user-details-modal/business-user-details-modal.component';
import { BusinessUserItem } from './business-user-item/business-user-item.component';
import { style } from './business-users.module.css';

interface Props {
  businessId: number;
}

export function BusinessUsers(props: Props) {

  const { businessId } = props;

  const businessUsers = BusinessStore.getBusinessUsers(businessId);
  const [businessUser, setBusinessUser] = useState<IBusinessUser>();
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [openUserModal, setOpenUserModal] = useState(false);

  function handleAddedUser(value: IBusinessUser) {
    setBusinessUser(value);
    setOpenUserModal(true);
  }

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <span>Nombre</span>
          <span>Usuario</span>
          <span>Estado</span>
          <OutlineButton
            style={style.addUser}
            text='Agregar usuario'
            onClick={() => setOpenAddUserModal(true)}/>
        </TableHeader>
        <tbody>
          {businessUsers?.map(value => (
            <BusinessUserItem
              key={value.id}
              businessId={businessId}
              businessUser={value}/>
          ))}
        </tbody>
      </Table>
      <AddBusinessUserModal
        open={openAddUserModal}
        businessId={businessId}
        onSaved={handleAddedUser}
        onClose={() => setOpenAddUserModal(false)}/>
      {businessUser &&
        <BusinessUserDetailsModal
          open={openUserModal}
          title='Usuario agregado'
          businessUser={businessUser}
          onClose={() => setOpenUserModal(false)}/>
      }
    </div>
  );
}
